(function ($) {
  const BREAK_MD = "screen and (min-width: 980px)";

  (function () {
    /**
     * 言語切り替えボタン
     */
    const $button = $(".js-lang-switch");
    const $list = $(".js-lang-list");
    $button.on("click", function () {
      if ($list.hasClass("is-open")) {
        $list.removeClass("is-open");
      } else {
        $list.addClass("is-open");
      }
    });
  })();

  (function () {
    /**
     * ドロワーメニュー
     */

    const $toggle_btn = $(".js-menutoggle");
    const $menu = $(".js-drawer-menu");
    const $close = $menu.find(".js-drawer-close");

    // ブレイクポイント対応
    let mql = window.matchMedia(BREAK_MD);

    function checkBreakPoint(mql) {
      if (mql.matches) {
        menuToggle("close");
      }
    }
    mql.addListener(checkBreakPoint);

    // スマホメニューの開閉
    function menuToggle(staet) {
      if (staet === "close") {
        $toggle_btn.removeClass("is-act");
        $menu.removeClass("is-open");
      } else if (staet === "open") {
        $toggle_btn.addClass("is-act");
        $menu.addClass("is-open");
      }
    }
    $toggle_btn.on("click", () => {
      if ($toggle_btn.hasClass("is-act")) {
        menuToggle("close");
      } else {
        menuToggle("open");
      }
    });
    $close.on("click", () => {
      menuToggle("close");
    });

    // サブメニューの開閉
    $(".menu-item a[href^='#']").on("click", (event) => {
      event.preventDefault();
      const $tg = $(event.target);
      if ($tg.hasClass("is-open")) {
        $tg.removeClass("is-open");
      } else {
        $tg.addClass("is-open");
      }
    });
  })();

  (function () {
    /**
     * ドロワー検索
     */

    const $toggle_btn = $(".js-drawertoggle");
    const $drawer = $(".js-drawer-search");
    const $close = $drawer.find(".js-drawer-close");

    // ブレイクポイント対応
    // let mql = window.matchMedia(BREAK_MD);

    // function checkBreakPoint(mql) {
    //   if (mql.matches) {
    //     drawerToggle("close");
    //   }
    // }
    // mql.addListener(checkBreakPoint);

    // スマホメニューの開閉
    function drawerToggle(staet) {
      if (staet === "close") {
        $toggle_btn.removeClass("is-act");
        $drawer.removeClass("is-open");
      } else if (staet === "open") {
        $toggle_btn.addClass("is-act");
        $drawer.addClass("is-open");
      }
    }
    $toggle_btn.on("click", () => {
      if ($toggle_btn.hasClass("is-act")) {
        drawerToggle("close");
      } else {
        drawerToggle("open");
      }
    });
    $close.on("click", () => {
      drawerToggle("close");
    });
  })();

  (function () {
    // スムーズスクロール
    function smooth_scroll(href) {
      const speed = 500;
      const topoffset = $("header").innerHeight() + 12;
      const target = $(
        href == "#" || href == "" || href == null ? "html" : href
      );
      let position = target.offset().top - topoffset;
      $("html, body").animate(
        {
          scrollTop: position,
        },
        speed,
        "swing"
      );
      return false;
    }
    $('a[href^="#"]').on("click", (event) => {
      const $tg = $(event.target);
      const href = $tg.attr("href");
      smooth_scroll(href);
      event.preventDefault();
      return false;
    });
    $(".js-btnToTop").on("click", (event) => {
      smooth_scroll("#");
      event.preventDefault();
      return false;
    });
  })();

  (function () {
    // サポートメニューの開閉
    const $tg = $(".js-support-navigation");
    const $btn = $(".js-support-navigation .support-nav-title button");
    $btn.on("click", (event) => {
      if ($tg.hasClass("is-open")) {
        $tg.removeClass("is-open");
      } else {
        $tg.addClass("is-open");
      }
      event.preventDefault();
      return false;
    });
  })();

  (function () {
    // スクロール連動

    // ヘッダー固定
    $(document).ready(function () {
      const $header = $(".js-header");
      // const header_h;
      let admin_h;
      const header_h = $header.outerHeight();
      if ($("#wpadminbar").length) {
        admin_h = $("#wpadminbar").outerHeight();
      } else {
        admin_h = 0;
      }

      $(window).bind("scroll", function () {
        let ws = $(window).scrollTop();
        if (ws > header_h + 10) {
          $(".l-site ").css("padding-top", header_h + "px");
          $header.css("top", admin_h + "px");
          $header.addClass("is-fix");
        } else {
          $(".l-site ").css("padding-top", "0px");
          $header.css("top", "0px");
          $header.removeClass("is-fix is-show");
          $header.css("transition-duration", "0s");
        }
        if (ws > 400) {
          if ($header.hasClass("is-fix")) {
            $header.css("transition-duration", "0.25s");
            $header.addClass("is-show");
          }
        } else {
          $header.removeClass("is-show");
        }

        //ページtopボタン
        const $topBtn = $(".js-btnToTop");
        if (ws > 500) {
          if (!$topBtn.hasClass("is-show")) {
            $topBtn.addClass("is-show");
          }
        } else {
          $topBtn.removeClass("is-show");
        }
      });
    });
  })();

  (function () {
    // ギャラリー
    $("a[data-rel^=lightcase]").lightcase();
  })();
})(jQuery);
